import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // Log to console for debugging (can be replaced with error reporting service)
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // Custom fallback UI if provided
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="min-h-screen bg-neutral-950 flex items-center justify-center p-4">
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-8 max-w-md w-full text-center">
            <div className="text-4xl mb-4">⚠️</div>
            <h2 className="text-xl font-semibold text-white mb-2">
              Bir şeyler ters gitti
            </h2>
            <p className="text-neutral-400 mb-6 text-sm">
              Beklenmeyen bir hata oluştu. Sayfa yeniden yüklenerek düzeltilebilir.
            </p>

            {process.env.NODE_ENV !== 'production' && this.state.error && (
              <details className="mb-4 text-left">
                <summary className="text-neutral-500 text-xs cursor-pointer hover:text-neutral-300 mb-2">
                  Hata detayları (geliştirici)
                </summary>
                <pre className="text-red-400 text-xs bg-neutral-800 p-3 rounded-lg overflow-auto max-h-40">
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}

            <div className="flex gap-3 justify-center">
              <button
                onClick={this.handleReset}
                className="px-4 py-2 bg-neutral-800 hover:bg-neutral-700 text-white rounded-lg text-sm transition-colors"
              >
                Tekrar Dene
              </button>
              <button
                onClick={this.handleReload}
                className="px-4 py-2 bg-amber-600 hover:bg-amber-500 text-white rounded-lg text-sm transition-colors"
              >
                Sayfayı Yenile
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

// Lightweight section-level error boundary for dashboard panels
class SectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`Section "${this.props.name || 'unknown'}" error:`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-neutral-900/50 border border-neutral-800 rounded-xl p-4 text-center">
          <p className="text-neutral-500 text-sm">
            {this.props.name || 'Bu bölüm'} yüklenirken hata oluştu.
          </p>
          <button
            onClick={() => this.setState({ hasError: false })}
            className="mt-2 text-amber-500 hover:text-amber-400 text-xs"
          >
            Tekrar dene
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
export { SectionErrorBoundary };
